<script lang="ts">
  import type { OrganizationPerformance } from "../../../../../api/kehrblatt/organization-performance"

  const { kind, performance, loading, failed } = $props<{
    kind: "usage" | "profit"
    performance?: OrganizationPerformance
    loading: boolean
    failed: boolean
  }>()

  const number = new Intl.NumberFormat("de-DE")
  const money = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" })
  const periods = $derived(
    (kind === "usage" ? [7, 30] : [7, 30, 90]).map((days) => ({
      days,
      value: performance?.periods.find((period) => period.days === days),
    })),
  )
  const reasons: Record<string, string> = {
    unpriced_usage: "Verbrauch ist noch nicht vollständig berechnet",
    unknown_mobile_transport: "WhatsApp oder SMS ist nicht belegt",
    missing_voice_duration: "Telefondauer fehlt",
    unknown_usage_metric: "Kostenansatz für eine Verbrauchsart fehlt",
    missing_plan: "Tarifdaten fehlen",
    missing_contract_end: "Vertragsende ist nicht belegt",
    missing_planning_history: "Planungshistorie ist unvollständig",
  }
</script>

<div class="performance-cell" aria-busy={loading}>
  {#if loading}
    <span>Wird geladen…</span>
  {:else if failed || !performance}
    <span>– <small>Nicht verfügbar</small></span>
  {:else}
    {#each periods as { days, value } (days)}
      <div class="period">
        <strong>{days} Tage:</strong>
        {#if !value}
          <span>–</span>
        {:else if kind === "usage"}
          <span>
            {value.planning_complete ? "" : "≥ "}{number.format(value.planned_work_orders)} Aufträge
            · {number.format(value.billed_credits)} Credits
          </span>
          {#if !value.planning_complete || !value.credits_complete}
            <small title={value.missing_data.map((reason) => reasons[reason] ?? reason).join(". ")}>
              Unvollständig
            </small>
          {/if}
        {:else if value.estimated_profit_cents === null}
          <span title={value.missing_data.map((reason) => reasons[reason] ?? reason).join(". ")}>
            – <small>Daten fehlen</small>
          </span>
        {:else}
          <span
            class:loss={value.estimated_profit_cents < 0}
            title={`Verbrauch: ${money.format(value.usage_revenue_cents / 100)} · Grundgebühr geschätzt: ${money.format((value.estimated_base_fee_cents ?? 0) / 100)} · Direkte Kosten: ${money.format((value.direct_cost_cents ?? 0) / 100)}`}
          >
            {money.format(value.estimated_profit_cents / 100)}
          </span>
        {/if}
      </div>
    {/each}
  {/if}
</div>

<style>
  .performance-cell {
    display: grid;
    gap: 0.25rem;
    font-variant-numeric: tabular-nums;
  }
  .period {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    align-items: baseline;
  }
  strong {
    font-size: 0.8rem;
    min-width: 3.4rem;
  }
  small {
    font-size: 0.75rem;
    opacity: 0.75;
  }
  .loss {
    color: var(--error-color, #b42318);
  }
</style>
